import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import { Container, Typography, Divider, Stack, Button } from "@mui/material";
import useResponsive from "../../../hooks/use-responsive";
import Logo from "../../../components/logo";
import { usePersistentState } from "../../../contexts/global-context";
import { SignUpForm } from "../../../sections/auth/signup";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { useState } from "react";
import { GOOGLE_LOGIN_KEY } from "../../../utils/constant";
import axios from "axios";
import APIS, { BaseUrl } from "../../../config/api";
import toast from "react-hot-toast";
import { SetLocalStorage } from "../../../utils/local-storage";
import palette from "../../../theme/palette";

const StyledRoot = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const StyledSection = styled("div")(({ theme }: any) => ({
  width: "100%",
  maxWidth: 480,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

const Footer = styled("div")(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: palette.grey[300],
  padding: 15,

  marginTop: "auto",
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export default function SignUp() {
  const [, dispatch]: any = usePersistentState();
  const mdUp = useResponsive("up", "md", "");
  const navigate = useNavigate();
  const [, setIsGoogleLogin] = useState(false);

  let year = new Date().getFullYear();
  const loginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse: any) => googleWithLogin(codeResponse),
    onError: (error) => console.log("Login Failed:", error),
  });

  const googleWithLogin = async (res: any) => {
    if (!res) return;
    let params = {
      token: res.access_token,
    };
    setIsGoogleLogin(true);
    axios
      .post(BaseUrl + APIS.GOOGLE_LOGIN, params, {
        headers: {
          Accept: "application/json",
          "x-api-key": GOOGLE_LOGIN_KEY,
        },
      })
      .then(async (response: any) => {
        setIsGoogleLogin(false);
        const res = response.data;

        if (res?.isSuccess) {
          dispatch({ users: res.result });
          SetLocalStorage("loginData", res.result);
          SetLocalStorage("isLogin", true);
          navigate("/dashboard/sales-report");
        } else {
          toast.error(res?.errors[0]);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsGoogleLogin(false);
      })
      .finally(() => {
        setIsGoogleLogin(false);
      });
  };

  return (
    <>
      <Helmet>
        <title> Login | EventPrix </title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: "fixed",
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hi, Welcome Back
            </Typography>
            <img
              src="/assets/illustrations/illustration_login.png"
              alt="login"
            />
          </StyledSection>
        )}
        <div style={{ paddingLeft: 0, paddingRight: 0, width: "100%" }}>
          <Container maxWidth="sm">
            <StyledContent>
              <Typography variant="h4" gutterBottom>
                Sign Up
              </Typography>

              <Stack direction="row" spacing={2}>
                <Button
                  fullWidth
                  size="large"
                  color="inherit"
                  variant="outlined"
                  onClick={() => {
                    loginWithGoogle();
                  }}
                >
                  <img
                    width="35"
                    height="35"
                    src="https://img.icons8.com/color/48/google-logo.png"
                    alt="google-logo"
                    style={{ marginRight: "5px" }}
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "text.secondary",
                      fontWeight: "600",
                      textTransform: "none",
                    }}
                  >
                    Sign up with Google
                  </Typography>
                </Button>
              </Stack>

              <Divider sx={{ my: 3 }}>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  OR
                </Typography>
              </Divider>

              <SignUpForm />
            </StyledContent>
          </Container>
          <Footer>
            <Typography>
              Copyright© {year} EventPrix LLC. All Rights Reserved.
            </Typography>
          </Footer>
        </div>
      </StyledRoot>
    </>
  );
}
